import React, { useState, useEffect, useMemo } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const ViewSupplierWithItem = () => {
   useAuthRedirect();
  const { sCode, sName } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
const [code, setCode] = useState(""); 
const [subDetails, setSubDetails] = useState({})
const [formData, setFormData] = useState({})
const navigate = useNavigate();
const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  /////////////////////////////////////////////////////////////
          const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
            const permsLoaded = !!rawPerms;
            
            //✅ Permission checks (safe even if perms not yet loaded; will be false)
            const canView  = hasPermission("Supplier with SubAssembly", "view");
            const canEntry = hasPermission("Supplier with SubAssembly", "entry");
            const canEdit = hasPermission("Supplier with SubAssembly", "edit");
            const canDel = hasPermission("Supplier with SubAssembly", "del");
            /////////////////////////////////////////////////////////////
     



useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        Swal.fire({
                        title: "Fetching Supplier Details",
                        html: `
                          <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                            <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                          </div>
                          <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Category Code...</p>
                        `,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                          const style = document.createElement("style");
                          style.innerHTML = `
                            @keyframes progressBar {
                              0% { width: 0% }
                              50% { width: 100% }
                              100% { width: 0% }
                            }
                          `;
                          document.head.appendChild(style);
                        },
                      });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${sCode}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeader1 = {
                supplierMaster_code: items[0].supplierMaster_code || "N/A",
                supplierMaster_name: items[0].supplierMaster_name || "N/A",
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1 || "N/A",
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2 || "N/A",
                supplierMaster_city : items[0].supplierMaster_city || "N/A",
                supplierMaster_pincode : items[0].supplierMaster_pincode || "N/A",
                
            };
            setSubDetails(storeReqHeader1);
            Swal.close();
      } catch (error) {
        Swal.close();
                     console.error("Error fetching Supplier Details. Please try again:", error);
                     Swal.fire({
                       icon: "error",
                       title: "Oops!",
                       text: "Error fetching Supplier Details. Please try again",
                     });
      }
    };
{canView && (
    fetchSupplierDetails()
)}
  }, [sCode, sCode]); 


  useEffect(() => {
    fetchData();
  }, [branch, sCode]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/supplierMaster_itemList?branch=${branch}&sCode=${sCode}`);

      console.log("API Response:", response.data.supplierList);
      setData(response.data.supplierList);
    } catch (error) {
      console.error("Error fetching supplierList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (sCode, itemCode) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!"
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        // show loading
        Swal.fire({
          title: "Submitting...",
          text: "Please wait while we process your request.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        // delete API call
        await axios.delete(
          `https://rfs2.infraconsoft.net.in/api/supplierWithItem_delete/${sCode}/${itemCode}`
        );

        // success alert then refresh list
        Swal.fire({
          title: "Deleted!",
          text: "Your record has been deleted.",
          icon: "success",
        }).then(() => {
          fetchData(); // refresh the supplier/item list
        });

      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to delete.",
          icon: "error",
        });
      }
    }
  });
};

if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                    <h2 className="add-txt">Supplier With Item - View</h2>
                    <Link to='/inventory/supplierWIsubassembly'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>

          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} />
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name}/>
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1"value={subDetails.supplierMaster_addressline1} />
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={subDetails.supplierMaster_addressline2}/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city"value={subDetails.supplierMaster_city} />
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={subDetails.supplierMaster_pincode}/>
              </div>
            </div>


              {/* Add New Button */}
              {canEntry && (
                    <div className="add-new-container">
                      <Link to={`/inventory/addNewSupplierWithItem/${sCode}/${sName}`}>
                        <button className="add-new-btn">
                          <i className="fa-solid fa-plus"></i> Add New Item
                        </button>
                      </Link>
                    </div>
              )}

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Price</th>
                    <th>GST%</th>
                    <th>P&F%</th>
                    <th>Disc%</th>
                    <th>Quality</th>
                    <th>After sales Support</th>
                    <th>Delivery</th>
                    {canEdit && (
                    <th>Edit</th>
                    )}
                    {canDel && (
                    <th>Delete</th>
                    )}
                    
                  </tr>
                </thead>
                <tbody>
  {loading ? (
    <tr>
      <td colSpan="13" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => {
      const ratings = item.SupplierWIDetail_promote.split(',').map(Number); // Convert string to array of numbers
      const ratingLabels = ["Poor", "Average", "Good", "Excellent"]; // Mapping for 0, 1, 2, 3

      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.supplierWIdetail_itemcode}</td>
          <td>{item.itemmaster_name}</td>
          <td>{item.itemMaster_purchaseUom}</td>
          <td>{item.supplierWIdetail_price}</td>
          <td>{item.SupplierWIDetail_CSTtax}</td>
          <td>{item.supplierWIdetail_PfPercentage}</td>
          <td>{item.supplierWIdetail_discountPercentage}</td>
          <td>{ratingLabels[ratings[0]] || "N/A"}</td> {/* Quality */}
          <td>{ratingLabels[ratings[1]] || "N/A"}</td> {/* After Sales Support */}
          <td>{ratingLabels[ratings[2]] || "N/A"}</td> {/* Delivery */}
          {canEdit && (
                    <td>
                               <Link to={`/inventory/modifySupplierWithItem/${sCode}/${sName}/${item.supplierWIdetail_itemcode}`}>
                                 <i className="fa-solid fa-pen-to-square edit"></i>
                               </Link>
                             </td>
                    )}
          
          {canDel && (
                   <td className="del">
                               <i className="fa-solid fa-trash-can " onClick={() => handleDelete(sCode, item.supplierWIdetail_itemcode)}></i>
                             </td>
                    )}
                            
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="13">No Data Available</td>
    </tr>
  )}
</tbody>

              </table>

            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ViewSupplierWithItem;
